import Services1Container from "../../../components/pages/other/Services1";

const Services1 = () => {
  return <Services1Container />;
};

export default Services1;
